import React, { useContext, useState } from 'react';
import { PersonContext } from './providers/Person.jsx';
import { s } from './Style.jsx';

const Menu = () => {

    const { user, authorizing, person, cart, orders } = useContext(PersonContext);
    const [menu, setMenu] = useState(false);

    return <>
        <div className='hideontablet'>

            <div id="menu-container" style={{ background: "white", padding: "10px 20px", borderBottom: "4px solid #cb2121", boxShadow: "0 10px 10px -10px #00000033", position: "fixed", top: 0, width: "100%", zIndex: 100, boxSizing: "border-box" }}>
                <div style={{ maxWidth: 1200, width: "100%", margin: "auto", display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "flex-end", }}>
                    <img style={{ objectFit: "contain", objectPosition: "left", height: 30 }} src="https://firebasestorage.googleapis.com/v0/b/versatile-express.appspot.com/o/newAssets%2Fversatile.png?alt=media&token=a5236a89-f3e8-4b5f-bd27-990ed4ce13ab" />
                    <span style={{ flex: 1 }}></span>
                    <a style={s.topMenuItemStyle} href="/">Home</a>
                    <a href="/cart?orderAnything" style={s.topMenuItemStyle}>Order Anything</a>

                    {authorizing && <i className="fas fa-spinner fa-spin"></i>}

                    {!user ? <>
                        <a style={s.topMenuItemStyle} href="/login">Login</a>
                    </> : <>
                        <a style={s.topMenuItemStyle} href="/cart">Cart {cart?.items?.length ? `(${cart?.items?.length})` : ""}</a>
                        <a style={s.topMenuItemStyle} href="/orders">Orders</a>
                        <a style={s.topMenuItemStyle} href="/account">Account</a>
                    </>}

                    <div className="hamburger" style={{ marginLeft: 10 }} onClick={() => setMenu(!menu)}>
                        {!menu ? <i className="fas fa-bars"></i> : <i className="fas fa-times"></i>}
                    </div>

                </div>
            </div>
        </div>


        <div className='showontablet'>

            <div id="menu-container" style={{ zIndex: 100, background: "white", padding: "10px 20px", borderBottom: "4px solid #cb2121", boxShadow: "0 10px 10px -10px #00000033", display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "space-between", position: "fixed", top: 0, width: "100%", boxSizing: "border-box" }}>

                <img style={{ height: 30 }} src="https://firebasestorage.googleapis.com/v0/b/versatile-express.appspot.com/o/newAssets%2Fversatile.png?alt=media&token=a5236a89-f3e8-4b5f-bd27-990ed4ce13ab" />
                <div className="hamburger" onClick={() => setMenu(!menu)}>
                    {!menu ? <i className="fas fa-bars"></i> : <i className="fas fa-times"></i>}
                </div>

            </div>
        </div>

        <div style={{ display: menu ? "flex" : "none", flexDirection: "column", alignItems: "center", justifyContent: "center", zIndex: 100 }}>

            <div onClick={() => setMenu(false)}
                style={{ position: "fixed", zIndex: 100, top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)" }}></div>
            <div style={{ position: "fixed", zIndex: 100, top: 0, right: 0, width: "80%", maxWidth: 500, height: "100%", display: "flex", flexDirection: "column", gap: 20, background: "#fff", borderRadius: 5, alignItems: "center", paddingTop: 60 }}>

                <img style={{ width: "82%", height: 50, objectFit: "contain", objectPosition: "right", marginBottom: 10 }} src="https://firebasestorage.googleapis.com/v0/b/versatile-express.appspot.com/o/newAssets%2Fversatile.png?alt=media&token=a5236a89-f3e8-4b5f-bd27-990ed4ce13ab" />

                <a style={s.menuItemStyle} href="/">Home</a>
                <a href="/cart?orderAnything" style={s.menuItemStyle}>Order Anything</a>

                {authorizing && <i className="fas fa-spinner fa-spin"></i>}

                {person?.roles && !!person.roles.length && <>
                    {person.roles.includes("admin") && <a style={s.menuItemStyle} href="/admin">Admin Dashboard</a>}
                    {person.roles.includes("dispatch") && <a style={s.menuItemStyle} href="/dispatch">Dispatch Dashboard</a>}
                    {/* {person.roles.includes("driver") && <a style={s.menuItemStyle} href="/driver">Driver Dashboard</a>} */}
                    {person.roles.includes("vendor") && <a style={s.menuItemStyle} href="/vendor">Vendor Dashboard</a>}
                </>}

                {!user ? <>
                    <a style={s.menuItemStyle} href="/login">Login</a>
                </> : <>
                    <a style={s.menuItemStyle} href="/cart">Cart {cart?.items?.length ? `(${cart?.items?.length})` : ""}</a>
                    <a style={s.menuItemStyle} href="/orders">Orders</a>
                    <a style={s.menuItemStyle} href="/account">Account</a>
                </>}

                <a style={s.menuItemStyle} href="/privacy-policy">Privacy Policy</a>

                <div className="hamburger" onClick={() => setMenu(!menu)} style={{ position: "absolute", top: 16, right: 20 }}>
                    {!menu ? <i className="fas fa-bars"></i> : <i className="fas fa-times"></i>}
                </div>

            </div>

        </div>

    </>;
}
export default Menu;